<template>
    <div class="sphere" :class="color">
        <div class="sphere--center">
            <slot name="center"></slot>
        </div>
        <div class="sphere--btns" id="sphere--btns">
            <slot name="buttons"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name:"Sphere",
    props: {
        items: {
            type: Number,
            default: 0
        },
        color : {
            type : String,
            default : "red"
        }
    },

    mounted() {
        this.updateButtons();
    },

    watch: {
        items() {
            this.updateButtons();
        }
    },

    methods: {
        updateButtons() {
            this.$nextTick(() => {
                const btns = document.getElementById("sphere--btns");
                if (btns === null) {
                    return;
                }
                let children = btns.children;
                for (let i = 0; i < children.length; i++) {
                    let style = this.getSpherePosition(i);
                    Object.assign(children[i].style, style);
                }
            });
        },

        getSpherePosition(idx) {
            const radius = 50;
            const startAngle = 25;

            let total = 1;
            if (this.items === 1) {
                idx = 1;
            } else {
                total = this.items - 1;
            }
            let angle = startAngle + idx / total * (180 - 2 * startAngle) - 90;
            angle = angle / 180 * Math.PI;

            let x = radius + Math.cos(angle) * radius;
            let y = radius + Math.sin(angle) * radius;

            return {
                left : x + "%",
                top : y + "%"
            };
        }
    }
};
</script>

<style lang="scss" scoped>
    $sphereSize : 60vh;

    .sphere {
        background-image: url('/img/sphere-red.svg');
        &.green {
            background-image: url('/img/sphere-green.svg');
        }
        &.blue {
            background-image: url('/img/sphere-blue.svg');
        }
        &.yellow {
            background-image: url('/img/sphere-yellow.svg');
        }
        &.orange {
            background-image: url('/img/sphere-orange.svg');
        }

        background-repeat: no-repeat;
        position: absolute;
        top : 50%;
        margin-top : math.div($sphereSize, -2);
        left: -36vh;
        width : $sphereSize;
        height : $sphereSize;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 4;
        @include widthBothIntro(650ms, 500ms, center);

        .sphere--center {
            position: relative;
            z-index: 4;
            width : 5rem;
            display: flex;
            justify-content: center;
        }

        .sphere--btns {
            width :100%;
            height : 100%;
            position: absolute;
            top : 0px;
            left : 0px;
        }
    }
</style>
